import { render, staticRenderFns } from "./Mana.vue?vue&type=template&id=12fcc7b2&scoped=true&"
import script from "./Mana.vue?vue&type=script&lang=js&"
export * from "./Mana.vue?vue&type=script&lang=js&"
import style0 from "./Mana.vue?vue&type=style&index=0&id=12fcc7b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fcc7b2",
  null
  
)

export default component.exports